module.exports = __webpack_public_path__ + "img/9788976827319.d9de4855.jpg";